import { capitalGlobalProposalsService } from '@/services/proposals/capital-global';
import type { ProposalSignatureMethodResponse } from '@/services/proposals/types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const capitalGlobalProposalSignatureMethodQueryKey = (policyId: string) =>
  ['capital-global-proposal-signature-method', policyId] as const;

export function useCapitalGlobalProposalSignatureMethod(policyId: string) {
  const trimmed = policyId.trim();

  return useQuery({
    queryKey: capitalGlobalProposalSignatureMethodQueryKey(trimmed),
    enabled: Boolean(trimmed),
    queryFn: async (): Promise<ProposalSignatureMethodResponse> => {
      const response =
        await capitalGlobalProposalsService.getProposalSignatureMethod(trimmed);

      if (!response.success) {
        throw new Error(
          response.error || 'Erro ao carregar método de assinatura'
        );
      }

      return response.data ?? { method: null, locked: false };
    },
  });
}

export function useChooseCapitalGlobalProposalPhysicalSignatureMethod(
  policyId: string
) {
  const queryClient = useQueryClient();
  const trimmed = policyId.trim();

  return useMutation({
    mutationFn: async () => {
      const response =
        await capitalGlobalProposalsService.chooseProposalSignatureMethod(
          trimmed,
          { method: 'physical' }
        );

      if (!response.success || !response.data) {
        throw Object.assign(
          new Error(response.error || 'Erro ao registrar assinatura física'),
          { statusCode: response.statusCode }
        );
      }

      return response.data;
    },
    onSuccess: data => {
      queryClient.setQueryData(
        capitalGlobalProposalSignatureMethodQueryKey(trimmed),
        data
      );
      void queryClient.invalidateQueries({ queryKey: ['proposals'] });
      void queryClient.invalidateQueries({
        queryKey: ['proposal', trimmed],
      });
    },
  });
}
